import Vue from "vue";

// Centralize sequence detection state
export default {
  sequence_workflow_new_add_node_id: Vue.observable({ value: "" }),
  sequence_workflow_current_node_id: Vue.observable({ value: "" }),
  sequence_workflow_current_plus_node: Vue.observable({ value: undefined }),
  sequence_workflow_current_plus_id: Vue.observable({ value: "" }),
  teams_relation_team_id: Vue.observable({ value: "" }),
  sequence_report_node_id: Vue.observable({ value: "" }),
  sequence_wizard_preview_node_id: Vue.observable({ value: "" }),
};
